import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MsalBroadcastService, MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent, MsalService } from '@azure/msal-angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from '../app.component';
import { ApiInterceptor } from '../interceptor/api.interceptor';
import { msalConfig } from '../models/constants/msal-config.constant';
import { routes } from '../routing/app.routes';
import { AppRoutingModule } from '../routing/app.routing.module';
import { SharedModule } from './shared.module';

const { msalInstance, msalGuardConfig, msalInterceptorConfig } = msalConfig;

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    AppRoutingModule,
    MsalModule.forRoot(msalInstance, msalGuardConfig, msalInterceptorConfig),
    SharedModule,
    HttpClientModule,
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      // loader: {
      //   provide: TranslateLoader,
      //   useFactory: () => new TranslateHttpLoader(http, './assets/i18n/', '.json')),
      //   deps: [HttpClient],
      // },
      loader: {
        provide: TranslateLoader,
        useFactory: (http: HttpClient) => { return new TranslateHttpLoader(http, './assets/i18n/', '.json') },
        deps: [HttpClient]
      },
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true,
    },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ],
  exports: [
    TranslateModule,
  ],
  bootstrap: [
    AppComponent,
    MsalRedirectComponent
  ]
})
export class AppModule { }
